import { isArray } from "lodash-es";
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import { isFunction } from "lodash";

const SelectInput = (props) => {
  const {
    onChange,
    selectList,
    children,
    defaultValue,
    selectName = "selectedValue",
    inputName = "inputValue",
    textAlign = "right",
    unitLabel,
    inputType = "text",
    className,
    onKeyUp,
    inputValue,
    inputOnChange
  } = props;

  const [_defaultValue, _setDefaultValue] = useState('');

  useEffect(() => {
    _setDefaultValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className={classnames("component-select-input", className)}>
      <select
        name={selectName}
        className="select"
        defaultValue={_defaultValue}
        onChange={onChange}
      >
        {children
          ? children
          : isArray(selectList) &&
          selectList.map(({ value, label }, idx) => (
            <option key={idx} value={value}>
              {label}
            </option>
          ))}
      </select>
      <div className="divider" />
      <input
        style={{ textAlign }}
        type={inputType}
        name={inputName}
        value={inputValue}
        className="input"
        onKeyUp={onKeyUp}
        onChange={(e) => {
          inputOnChange && isFunction(inputOnChange) ?
            inputOnChange(e, onChange)
            : onChange(e);
        }}
      />
      <p className="unit">{unitLabel}</p>
    </div>
  );
};
export default SelectInput;
